export enum INTERVIEW_STATUS {
    pending = 'pending',
    scheduled = 'scheduled',
    unavailable = 'unavailable',
    cancelled = 'cancelled',
    completed = 'completed',
    expired = 'expired',
}

export enum RESCHEDUlING_ERRORS {
    noAvailableSlots = 'NO_AVAILABLE_SLOTS_FOR_RESCHEDULE',
}

export enum SETTINGS_ERRORS {
    settingDisabled = 'INTERVIEW_SETTING_DISABLED',
    openInviteDisabled = 'OPEN_INVITE_DISABLED',
}

export enum OPEN_INVITE_ERRORS {
    alreadyRegistered = 'INTERVIEW_ALREADY_EXIST',
    somethingWentWrong = 'SOMETHING_WENT_WRONG',
    tooManyRequests = 'TOO_MANY_REQUESTS',
}

export enum INTERVIEW_ERRORS {
    alreadyExist = 'INTERVIEW_ALREADY_EXIST',
}
